import { inject, Injectable } from '@angular/core';
import { TranslocoLoader, TRANSLOCO_LOADER } from '@jsverse/transloco';
import { HttpClient } from '@angular/common/http';
import { catchError, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class HttpLoader implements TranslocoLoader {
  private http = inject(HttpClient);

  getTranslation(lang: string) {
    return this.http
      .get(`/assets/i18n/${lang}.json`)
      .pipe(catchError(() => of({})));
  }
}

export const httpLoader = { provide: TRANSLOCO_LOADER, useClass: HttpLoader };
